// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuTop_container__3rAVl","icon_item":"MenuTop_icon_item__1D6AD"};